import {
  Avatar,
  Badge,
  Button,
  Flex,
  Td,
  Text,
  Tr,
  Icon,
  Link,
  useColorModeValue,
  Modal,
  ModalBody,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  useColorMode,
  ModalCloseButton,
  ModalFooter,
  Grid,
  useDisclosure,
} from "@chakra-ui/react";
import NiceButton from "components/NiceButton/NiceButton.js";
import React, { useState } from "react";
import config from "config/index";
import { ToastContainer, toast } from 'react-toastify';
import removeMenu from "api/menu/remove-menu";
import editMenu from "api/menu/edit-menu";
import { RiMenuFill } from "react-icons/ri";
import IconBox from "components/Icons/IconBox";
import { Scrollbars } from 'react-custom-scrollbars';
import SubMenu from "components/SubMenus/SubMenu";
var moment = require('moment-jalaali')


function TablesTableRow(props) {

  const { data, isLast, setReload, reload } = props;
  const textColor = useColorModeValue("gray.500", "white");
  const titleColor = useColorModeValue("gray.700", "white");
  const bgStatus = useColorModeValue("gray.400", "navy.900");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const iconBlue = useColorModeValue("gray.100", "navy.700");
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { isOpen: isSubOpen, onOpen: onSubOpen, onClose: onSubClose } = useDisclosure()
  const { colorMode } = useColorMode();
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [subMenuData, setSubMenuData] = useState("");
  const [isUpdateLoading, setIsUpdateLoading] = useState("");
  function submit() {
    setIsUpdateLoading(true)
    let invalid = false;
    subMenuData.items.map(item => {
      if (item.href == "") {
        item.href = "#"
        item.target = "_self"
      }
      if (item.href.startsWith("#")) {
        item.target = "_self"
      } else if (!item.href.startsWith("http://") && !item.href.startsWith("https://")) {
        invalid = item.href;
        return;
      }
    })
    if (invalid) {
      toast.error("آدرس " + invalid + " نادرست است. آدرس‌های اینترنتی با https:// یا http:// آغاز می‌شوند.", {
        position: "bottom-right"
      })
      setIsUpdateLoading(false)
      return;
    }
    editMenu(
      subMenuData.address,
      subMenuData._id,
      subMenuData.title,
      subMenuData.items,
    ).then((result) => {
      onSubClose()
      setReload(!reload)
      return toast.success("با موفقیت انجام شد.", {
        position: "bottom-right"
      })
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsUpdateLoading(false)

    })
  }
  function Delete() {
    setIsDeleteLoading(true)
    removeMenu(data.address, data._id).then((result) => {
      setReload(!reload)
      onClose()
      return toast.success("با موفقیت انجام شد.", {
        position: "bottom-right"
      })
    }).catch((err) => {
      console.error(err)
      if (err?.response?.data?.message?.pr)
        return toast.error(err?.response?.data?.message?.pr, {
          position: "bottom-right"
        })
      else
        return toast.error("خطایی رخ داده است.", {
          position: "bottom-right"
        })
    }).finally(() => {
      setIsDeleteLoading(false)
    })
  }

  return (
    <>
      <Tr>
        <Td
          minWidth={{ sm: "250px" }}
          pl="0px"
          borderColor={borderColor}
          borderBottom={isLast ? "none" : null}
        >
          <Flex align="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
            <IconBox ml={"20px"} as='box' >
              <Icon h={"25px"} w={"25px"} color={titleColor} as={RiMenuFill} />
            </IconBox>
            <Flex direction="column">
              <Text
                fontSize="sm"
                color={titleColor}
                fontWeight="bold"
                minWidth="100%"
              >
                {data.title}
              </Text>
            </Flex>
          </Flex>
        </Td>
        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Text fontSize="xs" color={textColor} dir="ltr" textAlign="right" pb=".5rem">
            {moment(data.createdAt).format('jYYYY-jM-jD HH:mm:ss')}
          </Text>
        </Td>
        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Button
            onClick={onSubOpen}
            fontSize="xs"
            minW='110px'
            maxH='35px'>
            ویرایش
          </Button>
        </Td>
        <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
          <Button
            onClick={onOpen}
            color="red.400"
            fontSize="xs"
            minW='110px'
            maxH='35px'>
            حذف
          </Button>
        </Td>
      </Tr>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textAlign="center" fontSize="md">حذف منو</ModalHeader>
          <ModalCloseButton />
          <ModalBody fontSize="xs">
            منو به صورت بی بازگشت حذف خواهد شد، آیا مایل به حذف هستید؟
          </ModalBody>
          <ModalFooter>
            <Button fontSize='xs' onClick={onClose}>خیر</Button>
            <NiceButton mr="10px"
              color={colorMode === "dark" ? "white" : "black"}
              isLoading={isDeleteLoading}
              onClick={Delete}
              fontSize='xs'
              w="100px"
            >
              بله
            </NiceButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={isSubOpen} onClose={onSubClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontSize={"md"} textAlign="center">ویرایش منو</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Scrollbars dir="ltr" autoHeightMin={0}
              autoHide
              autoHideTimeout={1000}
              autoHideDuration={200}
              hideTracksWhenNotNeeded={true}
              autoHeight
              autoHeightMax={490} >
              <Grid dir="rtl" pr="20px">
                <SubMenu setSubMenuData={setSubMenuData} data={data} mt={"20px"} />

              </Grid>
            </Scrollbars>

          </ModalBody>
          <ModalFooter>
            <NiceButton
              color={colorMode === "dark" ? "white" : "black"}
              isLoading={isUpdateLoading}
              onClick={submit}
              fontSize='xs'
              w="100px">
              ثبت
            </NiceButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default TablesTableRow;
